import React from 'react';
import PdfViewer from '../../../shared/components/pdf-viewer/pdf-viewer';

/**
 * PDF body for AttachmentChip / AttachmentViewerModal in the admin portal (react-pdf via shared PdfViewer).
 */
export const ADMIN_ATTACHMENT_RENDER_CONTENT_BY_FILE_TYPE = {
  pdf: ({ fileUrl, fileName }) =>
    React.createElement(PdfViewer, { fileUrl, fileName }),
};
